// extracted by mini-css-extract-plugin
export default {"table-container":"MatchesList_table-container__Ul3UO","matches-table":"MatchesList_matches-table__uRF-C"};